import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { SalesTarget } from "../../../../components/modules/sales/sales-target";
import SalesTargetMiddleware from "../../../../middleware/modules/sales/sales-target";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
import IndexTarget from "../../../../components/modules/sales/sales-target/index-target";
// middlewares
const mapStateToProps = ({ auth, salesTarget }) => ({
  isProcessing: salesTarget.isProcessing,
  isError: salesTarget.isError,
  errorMessage: salesTarget.errorMessage,
  datalist: salesTarget.data,
  showModalTarget: salesTarget.showModalTarget,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => SalesTargetMiddleware.createTarget(),
      reset: () => SalesTargetMiddleware.resetList(),
      search: (data) => SalesTargetMiddleware.list(data),
      update: (data) => SalesTargetMiddleware.updateTarget(data),
      delete: (id, search) => SalesTargetMiddleware.beforeDelete(id, search),
      getHelperFull: (id, search) =>
        SalesTargetMiddleware.getHelperFull(id, search),
    },
    dispatch
  );
};
class IndexTargetContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  deleteItem(id, search) {
    this.props.delete(id, search);
  }
  updateItem(id) {
    this.props.getHelperFull();
    this.props.update(id);
  }
  createItem() {
    this.props.create();
    this.props.getHelperFull();
  }
  render() {
    const { isProcessing, search, datalist, showModalTarget } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Sales Target List")}
          </title>
        </Helmet>
      <IndexTarget
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModalTarget={showModalTarget}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexTargetContainer);
